<template>
  <div class="detail-wrap">
    <div class="article-container-detail">
      <div class="title-wrap">
        <div class="font-size-16 gray-92 title-text">{{ articleTitle }}</div>
      </div>
      <div class="content-wrap">
        <div class="content-left" id="wow-school-article-content-wrap">
          <h1 class="html-title">{{ articleTitle }}</h1>
          <div
            v-html="articleContent"
            class="html-wrap"
            @click="handleAttachClick"
          ></div>
        </div>
        <div class="content-right">
          <el-tabs v-model="activeName" @tab-click="handleTabChange">
            <el-tab-pane
              :label="
                '大纲' +
                (outlineList.length === 0 ? '' : `(${outlineList.length})`)
              "
              name="outline"
              class="tab-outline"
            >
              <div class="no-data" v-show="outlineList.length === 0">
                暂无大纲
              </div>
              <div
                :class="'outline-item' + ' ' + item.type"
                v-for="item in outlineList"
                :key="item.id"
                @click="toArticlePosition(item.id)"
              >
                {{ item.text }}
              </div>
            </el-tab-pane>
            <el-tab-pane
              :label="
                '附件' + (annexList.length === 0 ? '' : `(${annexList.length})`)
              "
              name="annex"
              class="tab-annex mwow-form"
            >
              <div class="no-data" v-show="annexList.length === 0">
                暂无附件
              </div>
              <div class="flex gray-92 annex-top" v-show="annexList.length > 0">
                <el-checkbox
                  v-model="selectAll"
                  @change="handleSelectAll"
                ></el-checkbox>
                <span class="top-select-all">全选</span>
                <span class="top-select-text">
                  已选
                  <span style="color: rgba(69, 177, 59, 1)">{{
                    selectCount.length
                  }}</span>
                  项
                </span>
                <div
                  class="top-download-all"
                  @click="handleAttachDownloadAll"
                  v-debounce="1000"
                >
                  批量下载
                </div>
              </div>
              <div
                v-for="(item, index) in annexList"
                :key="index"
                class="flex annex-item"
                @mouseleave="handleItemLeave"
              >
                <el-checkbox
                  v-model="item.checked"
                  @change="handleSelectItem"
                ></el-checkbox>
                <div
                  class="item-text"
                  @mouseenter="handleItemEnter(index)"
                  @click="toArticlePosition(item.uuid)"
                >
                  <span class="gray-92"
                    >{{ item.name }} ({{
                      handleSolveFileSize(item.size)
                    }})</span
                  >
                  <!-- v-if="enterIndex === index" -->
                  <div class="hover-wrap" v-if="enterIndex === index">
                    <div
                      class="flex hover-item"
                      @click="handleAttachPreview(item)"
                      v-debounce="1000"
                    >
                      <div class="hover-icon view-icon"></div>
                      <div>预览</div>
                    </div>
                    <div
                      class="flex hover-item hover-download"
                      @click="handleAttachDownload([item])"
                      v-debounce="1000"
                    >
                      <div class="hover-icon download-icon"></div>
                      <div>下载</div>
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <div class="content-bottom">
        <div class="bottom-auth">
          一级目录访问权限：<span>{{
            articleAuth
              .map((job) => {
                return job.job_name;
              })
              .join("、")
          }}</span>
        </div>
        <!-- <div class="bottom-time">
          <i class="el-icon-time"> </i>
          <span style="margin-left: 7px">{{ articleUpdateTime }}</span>
        </div> -->
      </div>
    </div>
    <!-- txt预览 -->
    <el-dialog
      :title="txtPreviewDialogTitle"
      :visible.sync="txtPreviewDialogVisible"
      destroy-on-close
      append-to-body
      width="60%"
    >
      <pre style="overflow: auto; max-height: 70vh">{{
        txtPreviewDialogContent
      }}</pre>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import { getDocDetailApi, handleDocDownloadAddApi } from "@/api/wow";
import { dateFormat } from "@/utils/timeFormat";
import eventBus from "@/utils/bus";
import { solveFileSize } from "@/utils/common";
import { UserModule } from "@/store/module/user";
export default {
  data() {
    return {
      docId: "",
      articleTitle: "",
      articleContent: "",
      articleAuth: [],
      articleUpdateTime: "",
      activeName: "outline",
      outlineList: [],
      annexList: [],
      selectAll: false,
      enterIndex: "",
      txtPreviewDialogVisible: false,
      txtPreviewDialogTitle: "",
      txtPreviewDialogContent: "",
    };
  },
  computed: {
    selectCount() {
      return this.annexList.filter((it) => {
        return it.checked;
      });
    },
    userInfo() {
      return UserModule.userInfo;
    },
  },
  watch: {
    $route: {
      handler() {
        this.getDetail();
      },
      immediate: true,
    },
  },
  methods: {
    handleSolveFileSize(size) {
      return solveFileSize(size);
    },
    getDetail() {
      this.annexList = [];
      this.outlineList = [];
      this.selectAll = false;
      this.enterIndex = "";
      getDocDetailApi({
        catalog_uuid: this.$route.query.catalog_uuid,
      }).then((res) => {
        if (res.error_code === 0) {
          this.docId = res.data.doc_id;
          this.articleTitle = res.data.title;
          // 解析出大纲，处理附件
          this.articleContent = this.solveArticleContent(res.data.content);
          this.articleAuth = res.data.job_auth;
          this.articleUpdateTime = dateFormat(
            "YYYY-mm-dd HH:MM",
            new Date(res.data.update_time * 1000).getTime()
          );
          this.$nextTick(() => {
            if (this.$route.query.attach_uuid) {
              this.toArticlePosition(this.$route.query.attach_uuid);
            }
          });
        } else if (res.error_code === 21050006) {
          this.$message({
            type: "warning",
            message: "文章已更新，返回首页",
          });
          eventBus.$emit("material-library-aside-refresh");
          this.$router.push({
            name: "materialLibraryList",
          });
        }
      });
    },
    toArticlePosition(id) {
      let target = document.getElementById(id);
      let wrap = document.getElementById("wow-school-article-content-wrap");
      wrap.scrollTo(0, target.offsetTop - 100);
    },
    solveArticleContent(text) {
      let wrapEl = document.createElement("div");
      wrapEl.innerHTML = text;
      let attachResult = [];
      // 解析出附件
      let attachs = wrapEl.querySelectorAll('span[data-w-e-type="attachment"]');
      for (let i = 0; i < attachs.length; i++) {
        attachs[i].id = attachs[i].attributes["data-uuid"].value;
        attachResult.push({
          name: attachs[i].attributes["data-name"].value,
          uuid: attachs[i].attributes["data-uuid"].value,
          link: attachs[i].attributes["data-link"].value,
          key: attachs[i].attributes["data-key"].value,
          size: attachs[i].attributes["data-size"].value,
          checked: false,
        });
        // 附件加入size
        let sizeEl = document.createElement("span");
        sizeEl.innerHTML = ` (${solveFileSize(
          Number(attachs[i].attributes["data-size"].value)
        )})`;
        attachs[i].append(sizeEl);
        // 附件加入预览和下载按钮
        let btnsEl = document.createElement("span");
        btnsEl.className = "content-attach-buttons-wrap";
        btnsEl.innerHTML = `<span class="content-attach-buttons">
          <span class="button attach-preview-button" data-name="${attachs[i].attributes["data-name"].value}" data-link="${attachs[i].attributes["data-link"].value}" data-key="${attachs[i].attributes["data-key"].value}">
            <i class="icon"></i><span class="text">预览</span>
            </span>  
          <span class="button attach-download-button" data-name="${attachs[i].attributes["data-name"].value}" data-link="${attachs[i].attributes["data-link"].value}" data-key="${attachs[i].attributes["data-key"].value}" data-uuid="${attachs[i].attributes["data-uuid"].value}">
            <i class="icon"></i><span class="text">下载</span>
            </span>  
        </span>`;
        attachs[i].appendChild(btnsEl);
      }
      // 解析出大纲
      let headersResult = [];
      let headers = wrapEl.querySelectorAll("h1,h2,h3,h4,h5");
      for (let i = 0; i < headers.length; i++) {
        headers[i].id = "wow-school-article-outline" + i;
        let text = headers[i].innerHTML.replace(/<.+?>/g, "");
        text = text.replace(/&nbsp;/g, "");
        if (text.trim()) {
          headersResult.push({
            id: "wow-school-article-outline" + i,
            type: headers[i].tagName,
            text: text.trim(),
          });
        }
      }
      this.outlineList = headersResult;
      this.annexList = attachResult;
      return wrapEl.innerHTML;
    },
    handleTabChange(evt) {
      this.activeName = evt.name;
    },
    handleSelectAll() {
      this.annexList.forEach((item) => {
        item.checked = this.selectAll;
      });
    },
    handleSelectItem() {
      this.selectAll = this.annexList.every((item) => {
        return item.checked;
      });
    },
    handleItemEnter(evt) {
      this.enterIndex = evt;
    },
    handleItemLeave() {
      this.enterIndex = "";
    },
    handleAttachClick(e) {
      // 监听正文附件点击
      if (e.target.className.indexOf("attach-preview-button") >= 0) {
        this.handleAttachPreview({
          name: e.target.attributes["data-name"].value,
          link: e.target.attributes["data-link"].value,
          key: e.target.attributes["data-key"].value,
        });
      }
      if (
        e.target.parentElement.className.indexOf("attach-preview-button") >= 0
      ) {
        this.handleAttachPreview({
          name: e.target.parentElement.attributes["data-name"].value,
          link: e.target.parentElement.attributes["data-link"].value,
          key: e.target.parentElement.attributes["data-key"].value,
        });
      }
      if (e.target.className.indexOf("attach-download-button") >= 0) {
        this.handleAttachDownload([
          {
            name: e.target.attributes["data-name"].value,
            link: e.target.attributes["data-link"].value,
            uuid: e.target.attributes["data-uuid"].value,
            key: e.target.attributes["data-key"].value,
          },
        ]);
      }
      if (
        e.target.parentElement.className.indexOf("attach-download-button") >= 0
      ) {
        this.handleAttachDownload([
          {
            name: e.target.parentElement.attributes["data-name"].value,
            link: e.target.parentElement.attributes["data-link"].value,
            uuid: e.target.parentElement.attributes["data-uuid"].value,
            key: e.target.parentElement.attributes["data-key"].value,
          },
        ]);
      }
    },
    handleAttachPreview(item) {
      let name = item.key.toLowerCase();
      if (
        /^.*\.(gif|bmp|jpeg|jpg|png|ico|mp3|ogg|wav|mp4|webm|mkv|pdf)$/.exec(
          name
        )
      ) {
        // 直接新页面打开
        window.open(item.link, "_blank");
      } else if (/^.*\.(doc|docx|xls|xlsx|ppt|pptx)$/.exec(name)) {
        // 微软文档在线预览
        window.open(
          "https://view.officeapps.live.com/op/view.aspx?src=" + item.link,
          "_blank"
        );
      } else if (/^.*\.(txt)$/.exec(name)) {
        // txt可能乱码
        axios.get(item.link).then((res) => {
          this.txtPreviewDialogTitle = item.name;
          this.txtPreviewDialogContent = res.data;
          this.txtPreviewDialogVisible = true;
        });
      } else {
        // 不提供预览
        // this.$alert({
        //   type: "error",
        //   message: "该文件不提供预览",
        // });
        this.$alert(`附件暂不支持预览，请直接下载查看`, `附件`, {
          type: "warning",
          confirmButtonText: "立即下载",
          confirmButtonClass: "mwow-button-filled mini",
          iconClass: "mwow-icon-error",
          callback: (action) => {
            if (action === "confirm") {
              this.handleAttachDownload([item]);
            }
          },
        });
      }
    },
    handleAttachDownloadAll() {
      if (this.selectCount.length === 0) {
        this.$message({
          type: "warning",
          message: "请先选择附件",
        });
        return false;
      }
      this.handleAttachDownload(this.selectCount);
    },
    handleAttachDownload(arr) {
      if (this.userInfo.is_super !== 1) {
        handleDocDownloadAddApi({
          file_list: [
            {
              doc_id: this.docId,
              file_uuid: arr.map((a) => {
                return a.uuid;
              }),
            },
          ],
        });
      }
      arr.map((attach) => {
        fetch(attach.link)
          .then((res) => res.blob())
          .then((blob) => {
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.style.display = "none";
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = attach.name;
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.detail-wrap {
  flex: 1;
}
.article-container-detail {
  display: flex;
  position: relative;
  height: 100%;
  flex-direction: column;
  .title-wrap {
    border-bottom: 1px solid rgba(231, 232, 234, 1);
    width: 100%;
    height: 44px;
    .title-text {
      padding: 0 0 0 21px;
      font-size: 15px;
      line-height: 44px;
      color: #5c5d5e;
    }
  }
  .content-wrap {
    flex: 1;
    width: 100%;
    height: 0;
    overflow: hidden;
    position: relative;
    .content-left {
      overflow: hidden auto;
      height: calc(100vh - 122px);
      margin: 20px 0 20px 30px;
      padding-right: 270px;
      &::-webkit-scrollbar {
        width: 4px;
      }
      &::-webkit-scrollbar-track {
        width: 4px;
        background: none;
      }
      &::-webkit-scrollbar-thumb {
        width: 4px;
        background: #d8d8d8;
      }
      &::-webkit-scrollbar-button {
      }
      .html-title {
        min-height: 54px;
        line-height: 54px;
        padding-bottom: 4px;
        font-size: 36px;
        font-weight: 700;
        max-width: 750px;
        margin: 13px auto 0 auto;
        color: #5c5d5e;
      }
      /deep/.html-wrap {
        max-width: 750px;
        margin: 0 auto 60px auto;
        font-size: 15px;
        color: #5c5d5e;
        line-height: 1.74;
        padding-top: 20px;
        p {
          font-size: 15px;
          line-height: 1.74;
          margin-top: 0;
          margin-bottom: 7.83px;
          span[data-w-e-type="attachment"]:first-child {
            margin-left: 0;
          }
        }
        h1 {
          font-size: 28px;
          line-height: 38px;
          margin-top: 38px;
          margin-bottom: 19px;
          font-weight: 700;
          &:first-child {
            margin-top: 0;
          }
        }
        h2 {
          font-size: 24px;
          line-height: 34px;
          margin-top: 34px;
          margin-bottom: 17px;
          font-weight: 700;
        }
        h3 {
          font-size: 20px;
          line-height: 30px;
          margin-top: 30px;
          margin-bottom: 15px;
          font-weight: 700;
        }
        h4 {
          font-size: 16px;
          line-height: 26px;
          margin-top: 26px;
          margin-bottom: 13px;
          font-weight: 700;
        }
        h5 {
          font-size: 16px;
          line-height: 24px;
          margin-top: 24px;
          margin-bottom: 12px;
          font-weight: 700;
        }
        strong {
          font-weight: bold !important;
        }
        em {
          font-style: italic !important;
        }
        span[data-w-e-type="attachment"] {
          display: inline-block;
          border: 1px solid #e7e8ea;
          border-radius: 5px;
          padding: 0 12px;
          margin: 6px;
          font-size: 14px;
          line-height: 28px;
          color: #5c5d5e;
          position: relative;
          .content-attach-buttons-wrap {
            display: none;
            position: absolute;
            right: 0;
            bottom: -66px;
            padding-top: 6px;
            z-index: 100;
            .content-attach-buttons {
              display: block;
              background-color: #fff;
              border: 1px solid #d9dadb;
              border-radius: 4px;
              padding: 5px 12px;
              .button {
                cursor: pointer;
                height: 24px;
                display: flex;
                align-items: center;
                &:hover {
                  span {
                    color: #45b13b;
                  }
                }
                i {
                  width: 16px;
                  height: 16px;
                  background-position: center;
                  background-size: 100% 100%;
                  margin-right: 6px;
                }
                span {
                  font-size: 12px;
                  color: #5c5d5e;
                  font-weight: 400;
                }
              }
              .attach-preview-button {
                .icon {
                  background-image: url("https://wowsite.musicwow.com/teaching_system_frontend/images/wowLibrary/view-false.png");
                }
                &:hover {
                  .icon {
                    background-image: url("https://wowsite.musicwow.com/teaching_system_frontend/images/wowLibrary/view-true.png");
                  }
                }
              }
              .attach-download-button {
                .icon {
                  background-image: url("https://wowsite.musicwow.com/teaching_system_frontend/images/wowLibrary/download-false.png");
                }
                &:hover {
                  .icon {
                    background-image: url("https://wowsite.musicwow.com/teaching_system_frontend/images/wowLibrary/download-true.png");
                  }
                }
              }
            }
          }
          &:hover {
            background-color: #ebf7eb;
            .content-attach-buttons-wrap {
              display: block;
            }
          }
          &::before {
            content: "";
            display: inline-block;
            height: 13px;
            width: 13px;
            background-image: url(https://wowsite.musicwow.com/teaching_system_frontend/images/wowLibrary/attach2.png);
            background-size: 100% 100%;
            margin-right: 12px;
            vertical-align: middle;
            margin-top: -1px;
          }
        }
        a {
          color: #45b13b;
          position: relative;
          text-decoration: none !important;
        }
        a:link {
          color: #45b13b;
        }

        a:visited {
          color: #45b13b;
        }

        a:hover {
          color: #45b13b;
        }

        a:active {
          color: #45b13b;
        }
        a::before {
          content: "";
          border-bottom: 1px solid #45b13b;
          position: absolute;
          left: 0;
          right: 0;
          bottom: -2px;
        }
        table {
          border-top: 1px solid #dcdfe6;
          border-left: 1px solid #dcdfe6;
          border-collapse: collapse;
          th {
            background-color: #fafafa;
          }
          th,
          td {
            border-right: 1px solid #dcdfe6;
            border-bottom: 1px solid #dcdfe6;
            min-width: 24px;
            min-height: 24px;
          }
        }
        img {
          max-width: 100%;
        }
        video {
          max-width: 100%;
        }
        ul {
          list-style-type: circle;
          li {
            list-style-type: circle;
            margin-left: 18px;
          }
        }
        ol {
          list-style-type: decimal;
          li {
            list-style-type: decimal;
            margin-left: 18px;
          }
        }
      }
    }
    /deep/.content-right {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 100;
      width: 250px;
      overflow: hidden;
      margin: 0 20px;
      .no-data {
        margin: 24px 0;
        font-size: 14px;
        color: #999;
        text-align: center;
      }
      .el-tabs {
        display: flex;
        flex-direction: column;
        height: 100%;
        .el-tabs__header {
          margin-bottom: 20px !important;
          .el-tabs__nav {
            .el-tabs__active-bar {
              background: rgba(69, 177, 59, 1) !important;
            }
            .is-active {
              color: rgba(69, 177, 59, 1) !important;
            }
            .el-tabs__item:hover {
              color: rgba(69, 177, 59, 1) !important;
            }
          }
        }
        .el-tabs__content {
          flex: 1;
          height: 0;
          overflow: hidden auto;
          .tab-annex {
            max-height: calc(100vh - 195px);
            overflow: hidden auto;
            &::-webkit-scrollbar {
              width: 4px;
            }
            &::-webkit-scrollbar-track {
              width: 4px;
              background: none;
            }
            &::-webkit-scrollbar-thumb {
              width: 4px;
              background: #d8d8d8;
            }
            &::-webkit-scrollbar-button {
            }
            .annex-top {
              margin-bottom: 8px;
              padding-left: 20px;
              .top-select-all {
                margin: 0 8px;
              }
              .top-download-all {
                margin-left: 20px;
                padding: 5px 10px;
                border: 1px solid rgba(69, 177, 59, 1);
                color: rgba(69, 177, 59, 1);
                border-radius: 4px;
                cursor: pointer;
              }
            }
            .el-checkbox__input.is-checked .el-checkbox__inner {
              background-color: #45b13b;
              border-color: #45b13b;
            }
            .annex-item {
              padding: 3px 0 3px 19px;
              align-items: start;
              &:last-child {
                padding-bottom: 100px;
              }
              span {
                word-break: break-all;
              }
              .el-checkbox {
                .el-checkbox__input {
                }
              }
              .item-text {
                flex: 1;
                margin: 0 8px;
                cursor: pointer;
                position: relative;
                line-height: 25px;
                font-size: 14px;
                color: #5c5d5e;
                .hover-wrap {
                  position: absolute;
                  bottom: -64px;
                  right: 0;
                  width: 50px;
                  padding: 11px;
                  border: 1px solid rgba(217, 218, 219, 1);
                  border-radius: 4px;
                  background: white;
                  z-index: 1000;
                  .hover-item {
                    line-height: 1;
                    .hover-icon {
                      width: 14px;
                      height: 14px;
                      margin-right: 5px;
                    }
                    .view-icon {
                      background: url("https://wowsite.musicwow.com/teaching_system_frontend/images/wowLibrary/view-false.png")
                        no-repeat center;
                      background-size: contain;
                    }
                    .download-icon {
                      background: url("https://wowsite.musicwow.com/teaching_system_frontend/images/wowLibrary/download-false.png")
                        no-repeat center;
                      background-size: contain;
                    }
                  }
                  .hover-item:hover {
                    color: rgba(69, 177, 59, 1);
                    .view-icon {
                      background: url("https://wowsite.musicwow.com/teaching_system_frontend/images/wowLibrary/view-true.png")
                        no-repeat center;
                      background-size: contain;
                    }
                    .download-icon {
                      background: url("https://wowsite.musicwow.com/teaching_system_frontend/images/wowLibrary/download-true.png")
                        no-repeat center;
                      background-size: contain;
                    }
                  }
                  .hover-download {
                    margin-top: 12px;
                  }
                }
              }
              .item-text:hover {
                span {
                  color: #45b13b;
                }
              }
            }
          }
          .tab-outline {
            max-height: calc(100vh - 195px);
            overflow: hidden auto;
            &::-webkit-scrollbar {
              width: 4px;
            }
            &::-webkit-scrollbar-track {
              width: 4px;
              background: none;
            }
            &::-webkit-scrollbar-thumb {
              width: 4px;
              background: #d8d8d8;
            }
            &::-webkit-scrollbar-button {
            }
            .outline-item {
              line-height: 34px;
              height: 34px;
              color: #333;
              cursor: pointer;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &:hover {
                color: #45b13b;
              }
              &.H1 {
                padding-left: 20px;
                font-size: 16px;
              }
              &.H2 {
                padding-left: 30px;
                font-size: 15px;
              }
              &.H3 {
                padding-left: 40px;
                font-size: 14px;
              }
              &.H4 {
                padding-left: 50px;
                font-size: 13px;
              }
              &.H5 {
                padding-left: 60px;
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }
  .content-bottom {
    padding: 11px 0 11px 21px;
    background: rgba(244, 245, 245, 1);
    .bottom-auth {
    }
    // .bottom-time {
    //   position: absolute;
    //   right: 294px;
    // }
  }
}
.flex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.gray-92 {
  color: rgba(92, 93, 94, 1);
}
.gray-140 {
  color: rgba(140, 141, 142, 1);
}
.font-size-16 {
  font-size: 16px;
}
.font-size-14 {
  font-size: 14px;
}
</style>
